import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

export const notificationApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    allNotifications: builder.mutation({
      query: (body) => ({
        url: END_POINTS.allNotifications,
        method: "POST",
        body,
      }),
    }),
    addNotification: builder.mutation({
      query: (body) => ({
        url: END_POINTS.addNotification,
        method: "POST",
        body,
      }),
    }),
    deleteNotification: builder.mutation({
      query: (id) => ({
        url: `${END_POINTS.deleteNotification}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAllNotificationsMutation,
  useAddNotificationMutation,
  useDeleteNotificationMutation,
} = notificationApi;
